import React, { useContext } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { AppContext } from "context/app";
import { LoginForm } from "v3/components/forms/LoginForm";
import { SimpleHeader } from "@pepdirect/ui/SimpleHeader";
import { useCurrentUserIdQuery } from "services/graphql/generated";
import { PageRoutes } from "constants/pageRoutes";
import { BrandConfigCustomizationsImage } from "services/graphql/generated";

export default function SignIn(): JSX.Element | null {
  const { tenant } = useContext(AppContext);
  const fallbackUrl = tenant?.fallbackUrl || "";
  const logo =
    tenant?.brandConfig?.customizations?.images?.find(
      (img: BrandConfigCustomizationsImage) => img.name === "logoSmallUrl"
    ) || null;
  const accountIconUrl = tenant?.brandConfig?.customizations?.images?.find(
    (img: BrandConfigCustomizationsImage) => img.name === "accountIconUrl"
  );
  const router = useRouter();
  const { data: currentUserId, loading: currentUserIdLoading } =
    useCurrentUserIdQuery();

  if (currentUserIdLoading) return null;

  if (currentUserId?.currentUser) {
    router.push(PageRoutes.account);
    return null;
  }

  return (
    <>
      <Head>
        <title>Login to {tenant?.brandConfig.title || "your account"}</title>
      </Head>
      {!accountIconUrl && (
        <SimpleHeader
          logo={{ src: logo?.src || "", alt: logo?.alt || "Shop logo" }}
          fallbackUrl={fallbackUrl}
        />
      )}
      <main>
        <LoginForm />
      </main>
    </>
  );
}
